import {
  Component,
  HostListener,
  Input,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RadioButtonInputModel } from 'src/app/presentation/general/radio-button/radio-button.component';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';

@Component({
  selector: 'app-fasting-days',
  templateUrl: './fasting-days.component.html',
  styleUrls: ['./fasting-days.component.scss'],
})
export class FastingDaysComponent implements OnInit, OnDestroy {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;

  fastingDays = 0;
  configButtons: RadioButtonInputModel[] = new Array();

  subscription: Subscription;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private generateShared: GenerateShared
  ) {
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.pageNumber === this.currentPageNumber) {
          if (this.isDetail) {
            this.generateShared.closeOverviewDetail();
          } else {
            this.generateShared.nextPage();
          }
          console.log('days', this.generateShared.getFastingDays());
        }
      }
    );
  }

  ngOnInit() {
    this.fastingDays = this.generateShared.selectedDietType.fasting;
    const titles = [
      'شنبه',
      'یکشنبه',
      'دوشنبه',
      'سه‌شنبه',
      'چهارشنبه',
      'پنجشنبه',
      'جمعه',
    ];
    for (let i = 0; i < titles.length; i++) {
      this.configButtons.push({
        title: titles[i],
        id: i,
        type: 'fastingDays',
      });
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
